import React from "react"
import classnames from "classnames"
import styles from "./Section.less"
import Container from "../Container/Container"
import componentParser from "AtomicUtils/componentParser"

class Section extends React.PureComponent {
  render() {
    let {
      fullWidth,
      overlay,
      backgroundColor,
      children,
      components = [],
      border,
      center=true,
      sizeName,
      gutter,
      horizontalPadding,
      verticalPadding,
      padding
    } = this.props

    let sizeNameTranspiled = "screen"


    if (!sizeName) {
      if (fullWidth) sizeNameTranspiled = ""
      else if (overlay) sizeNameTranspiled = ""
    }else {
      sizeNameTranspiled = sizeName
    }

    return (
      <div
        className={classnames({
          [styles.Section]: true,
          [styles.horizontalPadding]: horizontalPadding || padding,
          [styles.gutterPadding]: gutter,
          [styles.verticalPadding]: verticalPadding || padding,
          [styles.SectionBorder]: border
        })}
        style={{
          backgroundColor: backgroundColor || "transparent"
        }}
        >
        <Container styleName={sizeNameTranspiled}>
          <div
            className={classnames({
              [styles.ContainerInsideSection]: true,
              [styles.Center]: center
            })}>
            {componentParser(components, this.props, "Section") || children}
          </div>
        </Container>
      </div>
    )
  }
}

export default Section



// WEBPACK FOOTER //
// ./src/AtomicComponents/Section/Section.jsx